import ITextField, { ITextFieldProps } from '../textfield/i-textfield.component';
import './i-numberfield.component.scss';

const INumberField = (props: ITextFieldProps) => {
    const onActionEvent = (e: any) => {
        if (props.onActionEvent) {
            props.onActionEvent(e);
        }
    }

    return <ITextField
        {...props}
        type={'number'}
        onActionEvent={onActionEvent}
    />

};

export default INumberField;